<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Auditoria
      </div>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="search"
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        :loading="carregando"
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <div class="py-2 px-2">
              <v-row no-gutters align="center">
                <div class="mr-2">
                  <VueCtkDateTimePicker
                    v-on:callback="changeDates"
                    v-model="data_entrada"
                    class="date-picker"
                    locale="pt-BR"
                    :no-header="true"
                    :no-value-to-custom-elem="true"
                    :overlay="true"
                    :range="true"
                    :formatted="'L'"
                    :format="'YYYY-MM-DD'"
                    color="#EC6521"
                    :dark="$vuetify.theme.dark"
                    button-color="#EC6521"
                    :custom-shortcuts="labels"
                    :no-button="true"
                    :noClearButton="true"
                    :auto-close="true"
                    :loading="carregando"
                    :disabled="carregando"
                    :submit="retornoData()"
                  >
                    <v-btn class="px-2 search_data" elevation="0" v-ripple="{ class: `success--text` }">
                      <b class="text text-primary">
                        Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                      </b>
                    </v-btn>
                  </VueCtkDateTimePicker>
                </div>
                <v-form @submit.prevent="buscaItens()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="usuario"
                  :items="users"
                  clearable
                  hide-details=""
                  clear-icon="close"
                  label="Usuário"
                  class="mw_select ml-4"
                  append-icon="expand_more"
                  :loading="carregando || loadingUsers"
                  :disabled="carregando || loadingUsers"
                  @change="applyFilter()"
                  outlined
                >
                </v-autocomplete>
                <v-switch
                  hide-details
                  class="ml-4 mt-1 mb-2"
                  color="success"
                  v-model="inclusao"
                  :loading="carregando"
                  :disabled="carregando"
                  @change="applyFilter()"
                  label="Inclusão"
                ></v-switch>
                <v-switch
                  hide-details
                  class="ml-4 mt-1 mb-2"
                  color="success"
                  v-model="alteracao"
                  :loading="carregando"
                  :disabled="carregando"
                  @change="applyFilter()"
                  label="Alteração"
                ></v-switch>
                <v-switch
                  hide-details
                  class="ml-4 mt-1 mb-2"
                  color="success"
                  :loading="carregando"
                  :disabled="carregando"
                  v-model="exclusao"
                  @change="applyFilter()"
                  label="Exclusão"
                ></v-switch>
              </v-row>
            </div>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item @click="''">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">assignment</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para TXT</v-list-item-title>
                  </v-list-item>-->
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  components: {
    VueCtkDateTimePicker
  },
  data () {
    return {
      loading: true,
      salvando: false,
      search: '',
      searchFinal: '',
      carregando: false,
      total: 0,
      options: {},
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'log_id',
          sortable: false
        },
        { text: 'Data e hora', value: 'log_criado_em', sortable: false },
        { text: 'Método', value: 'log_method', sortable: false },
        { text: 'URL', value: 'log_url', sortable: false },
        { text: 'Status', value: 'log_status', sortable: false },
        { text: 'Usuário', value: 'usuario.usu_nome', sortable: false }
      ],
      dados: [],
      loadingUsers: false,
      users: [],
      usuario: '',
      inclusao: false,
      alteracao: false,
      exclusao: false,
      de: moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD'),
      ate: moment(new Date()).format('YYYY-MM-DD'),
      data_entrada: {
        // start: moment().startOf('month').format('YYYY-MM-DD'),
        start: moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ]
    }
  },
  watch: {
    options: {
      handler () {
        this.getDataFromApi()
      },
      deep: true
    }
  },
  methods: {
    changeDates (dates) {
      this.de = dates.start
      this.ate = dates.end
    },
    formatDateFront (date, format = 'L') {
      return moment(date).format(format)
    },
    retornoData () {
      if (this.data_entrada.start !== this.de || this.data_entrada.end !== this.ate) {
        if (this.data_entrada.end !== null) {
          this.de = this.data_entrada.start
          this.ate = this.data_entrada.end
          this.applyFilter()
        }
      }
    },
    async exportXls () {
      this.loadingXls = true
      const { page, itemsPerPage } = this.options
      let metodo = []

      if (this.inclusao) {
        metodo.push('inclusao')
      }
      if (this.alteracao) {
        metodo.push('alteracao')
      }
      if (this.exclusao) {
        metodo.push('exclusao')
      }
      Api.post('relatorios', {
        headers: this.someHeader(),
        usuario: this.usuario,
        metodo: metodo,
        busca: this.searchFinal,
        page: page,
        per_page: itemsPerPage,
        de: this.de,
        ate: this.ate,
        type: 'auditoria'
      })
        .then(res => {
          const baseUrl = window.location.origin
          this.downloadXls(baseUrl + '/' + res.data.url)
          // this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários') cabecalhos.push(header)
      })
      return cabecalhos
    },
    loadFunctions () {
      let filters = this.$route.query
      if (filters.de) this.de = filters.de
      if (filters.ate) this.ate = filters.ate
      if (filters.usuario) this.usuario = filters.usuario
      if (filters.inclusao) this.inclusao = true
      if (filters.alteracao) this.alteracao = true
      if (filters.exclusao) this.exclusao = true
      if (filters.busca) {
        this.search = filters.busca
        this.searchFinal = filters.busca
      }
      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }
      this.getDataFromApi()
      this.getUsers()
      this.loading = false
    },
    buscaItens () {
      this.searchFinal = this.search
      this.options.page = 1
      this.applyFilter()
    },
    limparBusca () {
      this.search = null
      this.searchFinal = null
      this.options.page = 1
      this.applyFilter()
    },
    applyFilter () {
      let query = Object.assign({},
        this.de ? { de: this.de } : '',
        this.ate ? { ate: this.ate } : '',
        this.searchFinal ? { busca: this.searchFinal } : '',
        this.usuario ? { usuario: this.usuario } : '',
        this.inclusao ? { inclusao: this.inclusao } : '',
        this.alteracao ? { alteracao: this.alteracao } : '',
        this.exclusao ? { exclusao: this.exclusao } : ''
      )
      this.$router.replace({name: 'Auditoria', query: query}).catch(() => {})
      this.options.page = 1
      this.getDataFromApi()
    },
    async getDataFromApi () {
      this.carregando = true
      this.dados = []
      this.total = 0
      // const { sortBy, sortDesc, page, itemsPerPage } = this.options
      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 10
      if (page) {
        pagina = page
      }
      if (itemsPerPage) {
        itensPagina = itemsPerPage
      }
      let filtro = `&de=${this.de}&ate=${this.ate}`
      if (this.searchFinal) filtro += '&busca=' + this.searchFinal
      if (this.usuario) filtro += '&usuario=' + this.usuario
      if (this.inclusao) filtro += '&metodo[]=inclusao'
      if (this.alteracao) filtro += '&metodo[]=alteracao'
      if (this.exclusao) filtro += '&metodo[]=exclusao'

      await Api.get(`logs?page=${pagina}&per_page=${itensPagina}${filtro}`)
        .then(res => {
          this.dados = res.data.data
          if (res.data.data.length > 0) {
            res.data.data.map(item => {
              item.log_criado_em = item.log_criado_em ? moment(item.log_criado_em).format('DD/MM/YYYY [às] HH:mm[hrs]') : ''
            })
          }
          this.total = res.data.total
          this.carregando = false
        })
        .catch(err => {
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getUsers () {
      this.loadingUsers = true
      await Api.get('usuarios')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                text: item.usu_nome,
                value: item.uuid_usu_id
              })
            })
            this.users = info
          }
          this.loadingUsers = false
        })
        .catch(err => {
          this.loadingUsers = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os usuários!',
            color: 'error'
          })
          console.log(err)
        })
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.mw_select {
  max-width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/pages/auditoria/Auditoria.vue